import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { appVersion } from '../../core/services/app-version';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  appVersion = appVersion;
  currentYear = new Date().getFullYear();
}
